
export function transformEmbed(serverEmbed) {
  if (!serverEmbed || !serverEmbed.id) return null

  const source = serverEmbed.source || 'upload'

  // Determine type: uploads can be image or video, embeds are always video
  let type = 'image' // default
  if (source !== 'upload') {
    type = 'video' // YouTube, TikTok, Vimeo, etc are always video
  } else if (serverEmbed.url) {
    // For uploads, check URL or content type to determine if it's a video
    const isVideo = serverEmbed.url.match(/\.(mp4|mov|avi|webm|quicktime)/i) ||
                   serverEmbed.content_type?.startsWith('video/')
    type = isVideo ? 'video' : 'image'
  }

  return {
    id: serverEmbed.id,
    url: serverEmbed.url || '',
    thumbUrl: serverEmbed.thumb_url || serverEmbed.url || '',
    mediumUrl: serverEmbed.medium_url || serverEmbed.url || '',
    largeUrl: serverEmbed.large_url || serverEmbed.url || '',
    source,
    externalId: serverEmbed.external_id || null,
    position: serverEmbed.position ?? 0,
    createdAt: serverEmbed.created_at,
    updatedAt: serverEmbed.updated_at,
    type, // Include type for MediaRenderer
  }
}

export function transformEmbeds(serverEmbeds) {
  if (!Array.isArray(serverEmbeds)) return []

  return serverEmbeds
    .map(transformEmbed)
    .filter(Boolean)
}
